// extracted by mini-css-extract-plugin
export default {"header":"EmptyHeader_header__N5y1","logo":"EmptyHeader_logo_lLaCE","logout":"EmptyHeader_logout_Sufmb"};